import Library from '../utility/Library';
//import User from '../../User';
//import Reader from './blueprint/Reader';

export default class Companion {

	constructor (run, model, params={}) {

		this.run = run;
		this.model = Library.getCompanion(model);

		this.run.notify('newcompanion', this, model);
	}

	get id () { return "companion"; }

	get key () { return "companion"; }

	get img () {

		return this.model.img;
	}

	get action () { return this.model.action }

	get multiplier () { return this.model.multiplier || 1 }

	get skill () { return this.model.skill }

	serialize () {

		return {
			model: this.model.key
		}
	}

	static build (run, src) {

		let companion = new Companion(run, src.model);
		return companion;
	}
}